import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Beans3 from '@/beans';
import { i18n, Utils } from '@/base/helpers';

import BirthDate from './BirthDate/BirthDate';
import { Twitter, Facebook, Instagram, TikTok, Snapchat } from './socials';

export default function ActionModal({ actionRule, isOpen, onClose, account, display }) {
  const [lattice, setLattice] = useState(null);
  const [currentTrellis, setCurrentTrellis] = useState(null);
  let ModalType;
  let pageLink;

  switch (actionRule.action.form) {
    case 'auth_facebook':
    case 'action_facebook':
      ModalType = Facebook;
      pageLink = lattice && lattice.facebook?.fb_page_url;
      setCurrentTrellis('facebook');
      break;
    case 'auth_twitter':
    case 'action_twitter':
      ModalType = Twitter;
      pageLink = lattice && lattice.twitter?.twitter_url;
      setCurrentTrellis('twitter');
      break;
    case 'auth_instagram':
    case 'action_instagram':
      ModalType = Instagram;
      pageLink = lattice && lattice.instagram?.instagram_url;
      setCurrentTrellis('instagram');
      break;
    case 'auth_tiktok':
    case 'action_tiktok':
      ModalType = TikTok;
      pageLink = lattice && lattice.tiktok?.tiktok_url;
      setCurrentTrellis('tiktok');
      break;
    case 'auth_snapchat':
    case 'action_snapchat':
      ModalType = Snapchat;
      pageLink = lattice && lattice.snapchat?.snapchat_url;
      setCurrentTrellis('snapchat');
      break;
    case 'birthday':
      ModalType = BirthDate;
      break;
    default:
      throw Error('Unsupported Liana rule form.');
  }

  useEffect(() => {
    Beans3.get({ path: `lattice/merchant/current/`, namespace: 'trellis' }).then((res) => {
      setLattice(res);
    });
  }, []);

  const onRuleActionVerify = (autoClose, that) => {
    that.setState({ loading: true });
    Beans3.post({ path: `${currentTrellis}/shopper/${account.id}/check_follow/`, namespace: 'trellis' })
      .then((follow) => {
        const newState = {
          loading: false,
          message: {
            text: follow.is_follow ? i18n.t('rules', 'reward_soon') : i18n.t('rules', 'verification'),
            color: Utils.BeansStatusColor.done.color,
          },
        };
        that.setState(newState);
      })
      .catch(() => {
        const newState = {
          loading: false,
          message: {
            text: i18n.t('rules', 'verification'),
            color: Utils.BeansStatusColor.done.color,
          },
        };
        that.setState(newState);
      });
  };

  return (
    <div
      style={{
        display: `${isOpen ? 'block' : 'none'}`,
        zIndex: '324568545',
        background: 'rgba(0, 0, 0, 0.4)',
        width: '100%',
        height: '100%',
        position: 'fixed',
        left: 0,
        top: 0,
        padding: '16px',
      }}
    >
      <ModalType
        onClose={onClose}
        actionRule={actionRule}
        onRuleActionVerify={onRuleActionVerify}
        pageLink={pageLink}
        currentTrellis={currentTrellis}
        account={account}
        display={display}
      />
    </div>
  );
}
